import * as z from 'zod';
import * as ba from './base';
import { assertVueComponent } from '../helpers';
export class NavigateAction extends ba.Action {
    static get manifest() {
        return {
            name: 'navigate',
            schema: z.object({
                location: z.union([
                    z.string(),
                    z.object({
                        name: z.string().optional(),
                        path: z.string().optional(),
                        hash: z.string().optional(),
                        query: z.record(z.any()).optional(),
                        params: z.record(z.any()).optional(),
                        append: z.boolean().optional(),
                        replace: z.boolean().optional()
                    })
                ])
            })
        };
    }
    async handle(event, args) {
        assertVueComponent(event.component);
        event.component.$router.push(args.location);
    }
}
//# sourceMappingURL=navigate.js.map